<template>
  <el-dialog
    :visible.sync="visible"
    width="760px"
    append-to-body
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <template slot="title">
      <div class="dialog-title">
        <img src="@/assets/images/upload.png" style="width: 20px; height: 20px; margin-right: 6px;" />
        <span>{{ isEdit ? '编辑收款账户' : '新增收款账户' }}</span>
      </div>
    </template>

    <div class="tip-banner">
      <i class="el-icon-warning" style="color: #faad14; margin-right: 6px;"></i>
      请填写您的银行卡信息，用于接收佣金打款
    </div>

    <el-form ref="formRef" :model="form" :rules="rules" label-position="top" label-width="0" v-loading="isLoading">
      <el-form-item label="姓名" prop="payeeName">
        <el-input v-model="form.payeeName" placeholder="请输入持卡人姓名"></el-input>
      </el-form-item>
      <el-form-item label="银行卡号" prop="bankCardNo">
        <el-input v-model="form.bankCardNo" placeholder="请输入银行卡号"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="bankName">
        <el-input v-model="form.bankName" placeholder="请输入开户行名称（如：中国工商银行上海分行）"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCardNo">
        <el-input v-model="form.idCardNo" placeholder="请输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobilePhone">
        <el-input v-model="form.mobilePhone" placeholder="请输入手机号"></el-input>
      </el-form-item>
    </el-form>

    <div class="warm-tip">
      <div class="warm-tip__title">
        <i class="el-icon-warning" style="color: #faad14; margin-right: 4px;"></i>温馨提示：
      </div>
      <div class="warm-tip__content">
        <p>1.请确保银行卡信息真实有效</p>
        <p>2.身份证号仅用于财务核对，不会对外泄露</p>
        <p>3.如信息有变，请及时更新</p>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确认提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
const RECEIPT_BANK_NAME_ALIPAY = '支付宝'

export default {
  name: 'ReceiptAccountFormDialog',
  props: {
    value: { type: Boolean, default: false },
    accountId: { type: [String, Number], default: null }
  },
  data() {
    return {
      submitting: false,
      isLoading: false,
      form: {
        payeeName: '',
        bankCardNo: '',
        bankName: '',
        idCardNo: '',
        mobilePhone: ''
      },
      rules: {
        payeeName: [{ required: true, message: '请输入持卡人姓名', trigger: 'blur' }],
        bankCardNo: [{ required: true, message: '请输入银行卡号', trigger: 'blur' }],
        bankName: [{ required: true, message: '请输入开户行名称', trigger: 'blur' }],
        idCardNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号格式不正确', trigger: 'blur' }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    visible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    },
    isEdit() {
      return !!this.accountId
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetForm()
          if (this.isEdit) {
            this.getDetail()
          }
        }
      }
    }
  },
  methods: {
    normalizeField(value) {
      return value === '-' ? '' : (value || '')
    },
    resetForm() {
      this.form = {
        payeeName: '',
        bankCardNo: '',
        bankName: '',
        idCardNo: '',
        mobilePhone: ''
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    handleClose() {
      this.resetForm()
      this.$emit('input', false)
      this.$emit('close')
    },
    getDetail() {
      this.isLoading = true
      this.$http('get', `mall/bdM2sSettlementChannelReceipt/detail/${this.accountId}`, {}).then(res => {
        if (!res) return
        if (res.bankName === RECEIPT_BANK_NAME_ALIPAY) {
          this.$message.warning('支付宝账户暂不支持编辑')
          this.handleClose()
          return
        }
        this.form.payeeName = res.payeeName || ''
        this.form.bankCardNo = res.bankCardNo || ''
        this.form.bankName = res.bankName || ''
        this.form.idCardNo = this.normalizeField(res.idCardNo)
        this.form.mobilePhone = this.normalizeField(res.mobilePhone)
      }).catch(() => {}).finally(() => {
        this.isLoading = false
      })
    },
    enableAsDefault(bankCardNo) {
      return this.$http('get', 'mall/bdM2sSettlementChannelReceipt/list', {
        page: 1,
        pageSize: 100
      }).then(res => {
        const records = (res && res.data) || []
        const target = records.find(item => item.bankCardNo === bankCardNo)
        if (target && target.id && target.status !== 1) {
          return this.$http('post', `mall/bdM2sSettlementChannelReceipt/updateStatus?id=${target.id}&status=1`)
        }
        return null
      })
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.submitting = true
        const payload = { ...this.form }
        const request = this.isEdit
          ? this.$http('post', 'mall/bdM2sSettlementChannelReceipt/update', { id: this.accountId, ...payload })
          : this.$http('post', 'mall/bdM2sSettlementChannelReceipt/add', payload)

        request.then(() => {
          if (!this.isEdit) {
            return this.enableAsDefault(payload.bankCardNo).finally(() => {
              this.$message.success('新增成功')
            })
          }
          this.$message.success('保存成功')
          return Promise.resolve()
        }).then(() => {
          this.$emit('on-success')
          this.handleClose()
        }).catch(() => {}).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.tip-banner {
  background: #FFFBE6;
  border: 1px solid #FFE58F;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.warm-tip {
  margin-top: 8px;
}
.warm-tip__title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
}
.warm-tip__content {
  font-size: 13px;
  color: #666;
  line-height: 22px;
}
.warm-tip__content p {
  margin: 0;
}
.dialog-footer {
  text-align: right;
}
</style>
